module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Praise for #1 internationally bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "centerfa"
  }, [_vm._v("Santa Montefiore")]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("“Santa Montefiore is a wonder.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("—Adriana Trigiani")]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("“Engaging and charming.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("—Penny Vincenzi")]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("“Santa Montefiore is a superb storyteller. One laughs as much as one cries.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("—Plum Sykes")]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("“Epic in scope and emotion . . . surprising, moving, and skilful.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("—Elizabeth Buchan")]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("“Montefiore’s writing is enchanting.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Hollywood Today")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("“Like her countrywomen Barbara Taylor Bradford and Penny Vincenzi, Montefiore excels at juxtaposing the opulent with the ordinary in delicately woven tales that seamlessly traverse borders and span decades.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("“Santa Montefiore is the new Rosemunde Pilcher.”")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Daily Mail")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f620084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 57
// module chunks = 0